function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#7C8084",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.67 3.33V1.71c0-.447-.363-.81-.81-.81-.447 0-.81.363-.81.81v1.62H9.81V1.71c0-.447-.363-.81-.81-.81-.447 0-.81.363-.81.81v1.62H4.95V1.71c0-.447-.363-.81-.81-.81-.447 0-.81.363-.81.81v1.62C1.988 3.33.9 4.418.9 5.76v8.91c0 1.342 1.088 2.43 2.43 2.43h11.34c1.342 0 2.43-1.088 2.43-2.43V5.76c0-1.342-1.088-2.43-2.43-2.43zM3.33 4.95v1.62c0 .447.363.81.81.81.447 0 .81-.363.81-.81V4.95h3.24v1.62c0 .447.363.81.81.81.447 0 .81-.363.81-.81V4.95h3.24v1.62c0 .447.363.81.81.81.447 0 .81-.363.81-.81V4.95c.447 0 .81.363.81.81v2.43H2.52V5.76c0-.447.363-.81.81-.81zm11.34 10.53H3.33c-.447 0-.81-.363-.81-.81V9.81h12.96v4.86c0 .447-.363.81-.81.81z",
  transform: "translate(-476 -226) translate(443 94) translate(33 123) translate(0 9)"
}))))));

var SvgIconCalendar = function SvgIconCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-calendar.568b7a66.svg";
export { ForwardRef as ReactComponent };